import { FileSystemEntity } from '@oneapp/main/containers/oa-file-explorer/oa-file-explorer.models';
import { BySport } from '@oneapp/main/core/sport/sport.models';
import { StateSliceDefaults, StateSliceName } from '@oneapp/main/core/store.models';

export interface S3BucketFilesAPI {
    generated: string;
    bucket: string;
    items: FileSystemEntity[];
}

export interface S3BucketStateModel {
    s3BucketFiles: BySport<FileSystemEntity>;
    selectedFileManagerBucketBySport: BySport<string>;
}

export const s3BucketStateDefaults: StateSliceDefaults<S3BucketStateModel> = Object.freeze({
    sliceName: StateSliceName.S3_BUCKET,
    defaults: {
        s3BucketFiles: {},
        selectedFileManagerBucketBySport: {}
    }
});
